<template>
  <div>
    <cangchu-kc />
  </div>
</template>

<script>
// 获取接口地址
import CangchuKc from '../components/ccManage/cckc/cangchuKc.vue'

export default {
  name: 'Cckc',
  components: {
    // sideMenu,
    // Header,
    CangchuKc
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
